import type { ReactNode } from 'react'
import { RecusaDaApi } from '../api/cliente'

export function Cabecalho({
  titulo,
  sub,
  acoes,
}: {
  titulo: string
  sub?: string
  acoes?: ReactNode
}) {
  return (
    <header className="cabecalho">
      <div>
        <div className="titulo">{titulo}</div>
        {sub && <div className="sub">{sub}</div>}
      </div>
      {acoes && <div className="acoes">{acoes}</div>}
    </header>
  )
}

/**
 * O que a API recusou, com todas as falhas de uma vez — a API devolve a lista inteira de
 * propósito, e mostrar só a primeira jogaria fora o que ela se deu ao trabalho de reunir.
 */
export function Erro({ erro, aoFechar }: { erro: unknown; aoFechar?: () => void }) {
  if (!erro) return null

  const recusa = erro instanceof RecusaDaApi ? erro : null
  const mensagem = recusa?.message ?? (erro instanceof Error ? erro.message : String(erro))

  return (
    <div className="erro" role="alert">
      <b>{mensagem}</b>
      {recusa && recusa.falhas.length > 0 && (
        <ul>
          {recusa.falhas.map((falha, i) => (
            <li key={i}>{falha}</li>
          ))}
        </ul>
      )}
      {aoFechar && (
        <div style={{ marginTop: 10 }}>
          <button className="btn g sm" onClick={aoFechar}>
            entendi
          </button>
        </div>
      )}
    </div>
  )
}

export function Carregando({ o }: { o: string }) {
  return (
    <div className="vazio">
      <span className="girando" /> carregando {o}…
    </div>
  )
}
